import Svg, { Circle, Defs, LinearGradient, Path, Stop } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const StatusSuccess = ({ width = 176, height = 176, color = '#00B259' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <Circle cx={88} cy={88} r={88} fill={color} opacity={0.05} />
    <Circle cx={88} cy={88} r={64} fill={color} opacity={0.05} />
    <Circle cx={88} cy={87.999} r={40} fill={color} />
    <Circle cx={87.871} cy={87.872} r={40} fill={color} />
    <Path
      fill="url(#a)"
      d="M88.141 76.877a11.264 11.264 0 1 0 0 22.528 11.264 11.264 0 0 0 0-22.528Zm5.868 8.684-6.758 6.758a1.126 1.126 0 0 1-1.6 0l-3.379-3.379a1.132 1.132 0 0 1 .8-1.93c.3 0 .588.119.8.33l2.58 2.592 5.958-5.97a1.131 1.131 0 0 1 1.6 1.6Z"
    />
    <Defs>
      <LinearGradient id="a" x1={87.068} x2={95.918} y1={77.413} y2={104.5} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </LinearGradient>
    </Defs>
  </Svg>
)
export default StatusSuccess
